import { render, staticRenderFns } from "./file-load.vue?vue&type=template&id=30849696&"
import script from "./file-load.vue?vue&type=script&lang=js&"
export * from "./file-load.vue?vue&type=script&lang=js&"
import style0 from "./file-load.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports